/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancelReminderDto,
  CompleteReminderDto,
  CreateReminderDto,
  DispatchNowDto,
  DispatchResultResponse,
  DueFollowUpsResponse,
  ReminderListResponse,
  ReminderResponse,
  RemindersDueParams,
  RemindersListParams,
  ShiftReminderDto,
  SnoozeReminderDto
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * به‌طور پیش‌فرض فقط یادآوری‌های باز (زمان‌بندی‌شده و به‌تعویق‌افتاده). برای دیدن ارسال‌شده‌ها، انجام‌شده‌ها و لغوشده‌ها includeClosed=true بفرستید.
 * @summary فهرست یادآوری‌ها
 */
export const remindersList = (
    params?: RemindersListParams,
 signal?: AbortSignal
) => {


      return apiClient<ReminderListResponse>(
      {url: `/api/v1/reminders`, method: 'GET',
        params, signal
    },
      );
    }




export const getRemindersListQueryKey = (params?: RemindersListParams,) => {
    return [
    `/api/v1/reminders`, ...(params ? [params] : [])
    ] as const;
    }


export const getRemindersListQueryOptions = <TData = Awaited<ReturnType<typeof remindersList>>, TError = void>(params?: RemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRemindersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof remindersList>>> = ({ signal }) => remindersList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RemindersListQueryResult = NonNullable<Awaited<ReturnType<typeof remindersList>>>
export type RemindersListQueryError = void


export function useRemindersList<TData = Awaited<ReturnType<typeof remindersList>>, TError = void>(
 params: undefined |  RemindersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersList>>,
          TError,
          Awaited<ReturnType<typeof remindersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersList<TData = Awaited<ReturnType<typeof remindersList>>, TError = void>(
 params?: RemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersList>>,
          TError,
          Awaited<ReturnType<typeof remindersList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersList<TData = Awaited<ReturnType<typeof remindersList>>, TError = void>(
 params?: RemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست یادآوری‌ها
 */

export function useRemindersList<TData = Awaited<ReturnType<typeof remindersList>>, TError = void>(
 params?: RemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRemindersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * برای پیگیری‌ای که از قاعدهٔ خدمت نمی‌آید. ruleId این ردیف null می‌ماند تا جاروی بعدیِ ساخت یادآوری‌ها آن را با یادآوری قاعده‌ای اشتباه نگیرد.
 * @summary ساخت یادآوری دستی
 */
export const remindersCreate = (
    createReminderDto: CreateReminderDto,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createReminderDto, signal
    },
      );
    }




export const getRemindersCreateMutationKey = () => ['remindersCreate'] as const;

export const getRemindersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersCreate>>, TError,RemindersCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersCreate>>, TError,RemindersCreateMutationVariables, TContext> => {

const mutationKey = getRemindersCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersCreate>>, RemindersCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  remindersCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof remindersCreate>>>
    export type RemindersCreateMutationBody = CreateReminderDto
    export type RemindersCreateMutationError = void
    export type RemindersCreateMutationVariables = {data: CreateReminderDto}

    /**
 * @summary ساخت یادآوری دستی
 */
export const useRemindersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersCreate>>, TError,RemindersCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersCreate>>,
        TError,
        RemindersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersCreateMutationOptions(options), queryClient);
    }
    /**
 * سه عدد و یک فهرست: چند پیگیری **عقب‌افتاده** است (عددی که اهمیت دارد)، چند تا امروز سررسید می‌شود، و چند تا در بازهٔ خواسته‌شده. فهرست از قدیمی‌ترین سررسید مرتب می‌شود تا پذیرش از بالای آن شروع کند.
 * @summary پیگیری‌های سررسیدشده — کارت داشبورد کلینیک
 */
export const remindersDue = (
    params?: RemindersDueParams,
 signal?: AbortSignal
) => {


      return apiClient<DueFollowUpsResponse>(
      {url: `/api/v1/reminders/due`, method: 'GET',
        params, signal
    },
      );
    }




export const getRemindersDueQueryKey = (params?: RemindersDueParams,) => {
    return [
    `/api/v1/reminders/due`, ...(params ? [params] : [])
    ] as const;
    }


export const getRemindersDueQueryOptions = <TData = Awaited<ReturnType<typeof remindersDue>>, TError = void>(params?: RemindersDueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRemindersDueQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof remindersDue>>> = ({ signal }) => remindersDue(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RemindersDueQueryResult = NonNullable<Awaited<ReturnType<typeof remindersDue>>>
export type RemindersDueQueryError = void


export function useRemindersDue<TData = Awaited<ReturnType<typeof remindersDue>>, TError = void>(
 params: undefined |  RemindersDueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersDue>>,
          TError,
          Awaited<ReturnType<typeof remindersDue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersDue<TData = Awaited<ReturnType<typeof remindersDue>>, TError = void>(
 params?: RemindersDueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersDue>>,
          TError,
          Awaited<ReturnType<typeof remindersDue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersDue<TData = Awaited<ReturnType<typeof remindersDue>>, TError = void>(
 params?: RemindersDueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیگیری‌های سررسیدشده — کارت داشبورد کلینیک
 */

export function useRemindersDue<TData = Awaited<ReturnType<typeof remindersDue>>, TError = void>(
 params?: RemindersDueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersDue>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRemindersDueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * همان کاری را می‌کند که کارِ زمان‌بندی‌شده هر ربع ساعت انجام می‌دهد، ولی فقط برای همین کلینیک: ساعات سکوت، انصراف بیمار از پیامک و اعتبار کیف پول همگی رعایت می‌شوند. **اعتبار پیامک کلینیک خرج می‌شود.** اگر اعتبار کافی نباشد چیزی ارسال نمی‌شود، یادآوری‌ها سرِ جایشان می‌مانند و skippedNoCredit شمرده می‌شود.
 * @summary ارسال دستی یادآوری‌های سررسیدشده
 */
export const remindersDispatchNow = (
    dispatchNowDto: DispatchNowDto,
 signal?: AbortSignal
) => {


      return apiClient<DispatchResultResponse>(
      {url: `/api/v1/reminders/dispatch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dispatchNowDto, signal
    },
      );
    }




export const getRemindersDispatchNowMutationKey = () => ['remindersDispatchNow'] as const;

export const getRemindersDispatchNowMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersDispatchNow>>, TError,RemindersDispatchNowMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersDispatchNow>>, TError,RemindersDispatchNowMutationVariables, TContext> => {

const mutationKey = getRemindersDispatchNowMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersDispatchNow>>, RemindersDispatchNowMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  remindersDispatchNow(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersDispatchNowMutationResult = NonNullable<Awaited<ReturnType<typeof remindersDispatchNow>>>
    export type RemindersDispatchNowMutationBody = DispatchNowDto
    export type RemindersDispatchNowMutationError = void
    export type RemindersDispatchNowMutationVariables = {data: DispatchNowDto}

    /**
 * @summary ارسال دستی یادآوری‌های سررسیدشده
 */
export const useRemindersDispatchNow = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersDispatchNow>>, TError,RemindersDispatchNowMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersDispatchNow>>,
        TError,
        RemindersDispatchNowMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersDispatchNowMutationOptions(options), queryClient);
    }
    /**
 * @summary جزئیات یک یادآوری
 */
export const remindersGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders/${id}`, method: 'GET', signal
    },
      );
    }




export const getRemindersGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/reminders/${id}`
    ] as const;
    }


export const getRemindersGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof remindersGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRemindersGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof remindersGetById>>> = ({ signal }) => remindersGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RemindersGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof remindersGetById>>>
export type RemindersGetByIdQueryError = void


export function useRemindersGetById<TData = Awaited<ReturnType<typeof remindersGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersGetById>>,
          TError,
          Awaited<ReturnType<typeof remindersGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersGetById<TData = Awaited<ReturnType<typeof remindersGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof remindersGetById>>,
          TError,
          Awaited<ReturnType<typeof remindersGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRemindersGetById<TData = Awaited<ReturnType<typeof remindersGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک یادآوری
 */

export function useRemindersGetById<TData = Awaited<ReturnType<typeof remindersGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof remindersGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRemindersGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * دلیل **اجباری** است و روی پرونده ثبت می‌شود؛ «چرا این بیمار برای ترمیم دعوت نشد؟» باید شش ماه بعد هم جواب داشته باشد. یادداشت عملیاتی موتور (مثل «اعتبار پیامک کافی نیست») پاک می‌شود چون دیگر معنا ندارد.
 * @summary جابه‌جایی زمان یادآوری
 */
export const remindersShift = (
    id: string,
    shiftReminderDto: ShiftReminderDto,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders/${id}/shift`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shiftReminderDto, signal
    },
      );
    }




export const getRemindersShiftMutationKey = () => ['remindersShift'] as const;

export const getRemindersShiftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersShift>>, TError,RemindersShiftMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersShift>>, TError,RemindersShiftMutationVariables, TContext> => {

const mutationKey = getRemindersShiftMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersShift>>, RemindersShiftMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  remindersShift(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersShiftMutationResult = NonNullable<Awaited<ReturnType<typeof remindersShift>>>
    export type RemindersShiftMutationBody = ShiftReminderDto
    export type RemindersShiftMutationError = void
    export type RemindersShiftMutationVariables = {id: string;data: ShiftReminderDto}

    /**
 * @summary جابه‌جایی زمان یادآوری
 */
export const useRemindersShift = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersShift>>, TError,RemindersShiftMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersShift>>,
        TError,
        RemindersShiftMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersShiftMutationOptions(options), queryClient);
    }
    /**
 * یکی از until یا days را بفرستید. سررسید هم با آن جابه‌جا می‌شود — تعویقی که فقط snoozedUntil را تغییر دهد، یادآوری را هر ربع ساعت دوباره سررسید نشان می‌دهد.
 * @summary تعویق یادآوری
 */
export const remindersSnooze = (
    id: string,
    snoozeReminderDto: SnoozeReminderDto,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders/${id}/snooze`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: snoozeReminderDto, signal
    },
      );
    }




export const getRemindersSnoozeMutationKey = () => ['remindersSnooze'] as const;

export const getRemindersSnoozeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersSnooze>>, TError,RemindersSnoozeMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersSnooze>>, TError,RemindersSnoozeMutationVariables, TContext> => {

const mutationKey = getRemindersSnoozeMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersSnooze>>, RemindersSnoozeMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  remindersSnooze(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersSnoozeMutationResult = NonNullable<Awaited<ReturnType<typeof remindersSnooze>>>
    export type RemindersSnoozeMutationBody = SnoozeReminderDto
    export type RemindersSnoozeMutationError = void
    export type RemindersSnoozeMutationVariables = {id: string;data: SnoozeReminderDto}

    /**
 * @summary تعویق یادآوری
 */
export const useRemindersSnooze = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersSnooze>>, TError,RemindersSnoozeMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersSnooze>>,
        TError,
        RemindersSnoozeMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersSnoozeMutationOptions(options), queryClient);
    }
    /**
 * قاعدهٔ خدمت دست‌نخورده می‌ماند و برای بیماران دیگر همچنان اجرا می‌شود.
 * @summary لغو یادآوری برای این بیمار
 */
export const remindersCancel = (
    id: string,
    cancelReminderDto: CancelReminderDto,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders/${id}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelReminderDto, signal
    },
      );
    }




export const getRemindersCancelMutationKey = () => ['remindersCancel'] as const;

export const getRemindersCancelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersCancel>>, TError,RemindersCancelMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersCancel>>, TError,RemindersCancelMutationVariables, TContext> => {

const mutationKey = getRemindersCancelMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersCancel>>, RemindersCancelMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  remindersCancel(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersCancelMutationResult = NonNullable<Awaited<ReturnType<typeof remindersCancel>>>
    export type RemindersCancelMutationBody = CancelReminderDto
    export type RemindersCancelMutationError = void
    export type RemindersCancelMutationVariables = {id: string;data: CancelReminderDto}

    /**
 * @summary لغو یادآوری برای این بیمار
 */
export const useRemindersCancel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersCancel>>, TError,RemindersCancelMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersCancel>>,
        TError,
        RemindersCancelMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersCancelMutationOptions(options), queryClient);
    }
    /**
 * با «ارسال‌شده» فرق دارد: ارسال‌شده یعنی پیامک رفت، انجام‌شده یعنی یک آدم پیگیری را بست. یادآوری می‌تواند بدون ارسال هم انجام‌شده باشد (بیمار خودش تماس گرفت) و همین حالت است که کلینیک واقعاً می‌خواهد.
 * @summary ثبت انجام پیگیری
 */
export const remindersComplete = (
    id: string,
    completeReminderDto: CompleteReminderDto,
 signal?: AbortSignal
) => {


      return apiClient<ReminderResponse>(
      {url: `/api/v1/reminders/${id}/complete`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: completeReminderDto, signal
    },
      );
    }




export const getRemindersCompleteMutationKey = () => ['remindersComplete'] as const;

export const getRemindersCompleteMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersComplete>>, TError,RemindersCompleteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindersComplete>>, TError,RemindersCompleteMutationVariables, TContext> => {

const mutationKey = getRemindersCompleteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindersComplete>>, RemindersCompleteMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  remindersComplete(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindersCompleteMutationResult = NonNullable<Awaited<ReturnType<typeof remindersComplete>>>
    export type RemindersCompleteMutationBody = CompleteReminderDto
    export type RemindersCompleteMutationError = void
    export type RemindersCompleteMutationVariables = {id: string;data: CompleteReminderDto}

    /**
 * @summary ثبت انجام پیگیری
 */
export const useRemindersComplete = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindersComplete>>, TError,RemindersCompleteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof remindersComplete>>,
        TError,
        RemindersCompleteMutationVariables,
        TContext
      > => {
      return useMutation(getRemindersCompleteMutationOptions(options), queryClient);
    }
